
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Layout, Position } from '@drawbotics/react-drylus';
import Playground, { PropsTable } from '~/components/Playground';
export const Sidebar = ({
  width
}) => {
  return <div style={{
    width: width || 200,
    height: '100%',
    background: 'red',
    padding: 20
  }}>Sidebar</div>;
};
export const Navbar = () => {
  return <div style={{
    height: 60,
    width: '100%',
    background: 'blue',
    padding: 20
  }}>Navbar</div>;
};
export const BottomBar = () => {
  return <div style={{
    height: 60,
    width: '100%',
    background: 'pink',
    padding: 20
  }}>Bottom bar</div>;
};

const layoutProps = {
  Sidebar,
Navbar,
BottomBar
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





<h1>{`Layout component`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Layout } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Examples`}</strong></p>
<PropsTable component={Layout} mdxType="PropsTable" />
<p>{`Example with fixed navbar and standard bottom bar`}</p>
<Playground __position={1} __code={`<div style={{ height: 400 }}>
  <Layout bar={<Navbar />} position={Position.TOP} fixed>
    <Layout bar={<BottomBar />} position={Position.BOTTOM}>
      <div style={{ background: 'green', height: 500, padding: 20 }}>Content</div>
    </Layout>
  </Layout>
</div>`} mdxType="Playground">
  <div style={{
        height: 400
      }}>
    <Layout bar={<Navbar mdxType="Navbar" />} position={Position.TOP} fixed mdxType="Layout">
      <Layout bar={<BottomBar mdxType="BottomBar" />} position={Position.BOTTOM} mdxType="Layout">
        <div style={{
              background: 'green',
              height: 500,
              padding: 20
            }}>Content</div>
      </Layout>
    </Layout>
  </div>
</Playground>
<p>{`Example like Backoffice layout`}</p>
<Playground __position={2} __code={`<div style={{ height: 400 }}>
  <Layout bar={<Sidebar />} position={Position.LEFT} fixed>
    <Layout bar={<Navbar />} position={Position.TOP}>
      <div style={{ background: 'green', height: 500, padding: 20 }}>Content</div>
    </Layout>
  </Layout>
</div>`} mdxType="Playground">
  <div style={{
        height: 400
      }}>
    <Layout bar={<Sidebar mdxType="Sidebar" />} position={Position.LEFT} fixed mdxType="Layout">
      <Layout bar={<Navbar mdxType="Navbar" />} position={Position.TOP} mdxType="Layout">
        <div style={{
              background: 'green',
              height: 500,
              padding: 20
            }}>Content</div>
      </Layout>
    </Layout>
  </div>
</Playground>
<p>{`Example with sidebar and floating bottom bar`}</p>
<Playground __position={3} __code={`<div style={{ height: 400 }}>
  <Layout bar={<BottomBar />} position={Position.BOTTOM} fixed>
    <Layout bar={<Navbar />} position={Position.TOP}>
      <Layout bar={<Sidebar width={400} />} position={Position.RIGHT}>
        <div style={{ background: 'green', height: 500, padding: 20 }}>Content</div>
      </Layout>
    </Layout>
  </Layout>
</div>`} mdxType="Playground">
  <div style={{
        height: 400
      }}>
    <Layout bar={<BottomBar mdxType="BottomBar" />} position={Position.BOTTOM} fixed mdxType="Layout">
      <Layout bar={<Navbar mdxType="Navbar" />} position={Position.TOP} mdxType="Layout">
        <Layout bar={<Sidebar width={400} mdxType="Sidebar" />} position={Position.RIGHT} mdxType="Layout">
          <div style={{
                background: 'green',
                height: 500,
                padding: 20
              }}>Content</div>
        </Layout>
      </Layout>
    </Layout>
  </div>
</Playground>
<p>{`Example with fixed sidebar and navbar`}</p>
<Playground __position={4} __code={`<div style={{ height: 400 }}>
  <Layout bar={<Navbar />} position={Position.TOP} fixed barScrollable={false}>
    <Layout bar={<Sidebar />} position={Position.LEFT} fixed style={{ height: '100%' }}>
      <div>
        <div style={{ background: 'green', height: 500, padding: 20 }}>Content</div>
      </div>
    </Layout>
  </Layout>
</div>`} mdxType="Playground">
  <div style={{
        height: 400
      }}>
    <Layout bar={<Navbar mdxType="Navbar" />} position={Position.TOP} fixed barScrollable={false} mdxType="Layout">
      <Layout bar={<Sidebar mdxType="Sidebar" />} position={Position.LEFT} fixed style={{
            height: '100%'
          }} mdxType="Layout">
        <div>
          <div style={{
                background: 'green',
                height: 500,
                padding: 20
              }}>Content</div>
        </div>
      </Layout>
    </Layout>
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;